<div class="d-flex jc-c my-3 my-md-5">
    <h2 class="c-brand ta-c text--medium tittle-bienvenido">Bienvenidos a Estado de Situaci&oacute;n</h2>
</div>
